import { t } from '../theme/locales';
const DEFAULT_WISHLIST_NAME = t('wishlist.swym_default_list_name', 'Wishlist');
/* Fetches the wishlist data. */ const fetchLists = async (swat)=>{
    return new Promise((resolve, reject)=>{
        const onSuccess = (lists)=>{
            window.swymWishLists = lists;
            const [oldestList] = lists.sort((a, b)=>a.cts - b.cts);
            window.swymSelectedListId = oldestList === null || oldestList === void 0 ? void 0 : oldestList.lid;
            window.swymSelectedListName = oldestList === null || oldestList === void 0 ? void 0 : oldestList.lname;
            resolve(lists);
        };
        const onError = (error)=>{
            reject(error);
        };
        swat.fetchLists({
            callbackFn: onSuccess,
            errorFn: onError
        });
    });
};
/* Create a new wishlist if it doesn't already exist. */ const createList = (swat, lname, defaultWishlist = false)=>{
    return new Promise((resolve, reject)=>{
        let onSuccess = async function(newList) {
            resolve(newList);
        };
        let onError = function(error) {
            reject(error);
        };
        if (defaultWishlist) {
            swat.createList({
                lname: DEFAULT_WISHLIST_NAME
            }, onSuccess, onError);
        } else if (lname) {
            swat.createList({
                lname
            }, onSuccess, onError);
        }
    });
};
/* Fetch a specific wishlist by its Lid. */ const fetchList = async (lid, swat)=>{
    return new Promise((resolve, reject)=>{
        // Define success callback
        let onSuccess = function(listDetails) {
            // Successfully fetched list details
            resolve(listDetails.list);
        };
        // Define error callback
        let onError = function(error) {
            // Error is an xhrObject
            console.error('Error while fetching List details', error);
            reject(error);
        };
        // Call `fetchListDetails` with the above callbacks and listConfig
        swat.fetchListDetails({
            lid: lid
        }, onSuccess, onError);
    });
};
/* Refreshes the wishlist by fetching the list again in the global scope. */ const refreshLists = async (swat)=>{
    window.swymWishLists = undefined;
    const lists = await fetchLists(swat);
    return lists;
};
/* Adds product to wishlist action. */ const addToWishlist = async (lid, swat, product)=>{
    let targetListId = lid;
    if (!targetListId) {
        const list = await createList(swat, DEFAULT_WISHLIST_NAME, true);
        targetListId = list.lid;
    }
    if (!targetListId) {
        throw new Error('No wishlist ID found');
    }
    const resolvedListId = targetListId;
    return new Promise((resolve, reject)=>{
        const onSuccess = (addedListItem)=>{
            resolve(addedListItem);
        };
        const onError = (error)=>{
            console.error('Error adding product to wishlist:', error);
            reject(error);
        };
        swat.addToList(resolvedListId, product, onSuccess, onError);
    });
};
/* Remove product from wishlist action. */ const removeFromWishlist = async (lid, swat, product)=>{
    return new Promise((resolve, reject)=>{
        const onSuccess = async (deletedProduct)=>{
            resolve(deletedProduct);
        };
        const onError = (error)=>{
            console.error('Error removing product from wishlist:', error);
            reject(error);
        };
        swat.deleteFromList(lid, product, onSuccess, onError);
    });
};
/* Delete a list by its Lid */ const deleteList = async (lid, swat)=>{
    return new Promise((resolve, reject)=>{
        let onSuccess = async function(deletedListObj) {
            resolve(deletedListObj);
        };
        let onError = function(error) {
            reject(error);
        };
        swat.deleteList(lid, onSuccess, onError);
    });
};
/* Rename/edit an existing list by its Lid */ const editList = async (lid, lname, swat)=>{
    return new Promise((resolve, reject)=>{
        const onSuccess = async function(updatedList) {
            resolve(updatedList);
        };
        const onError = function(error) {
            reject(error);
        };
        if (typeof swat.updateList === 'function') {
            swat.updateList({
                lid,
                lname
            }, onSuccess, onError);
            return;
        }
        reject(new Error('List rename method is not available on Swym API'));
    });
};
const getShareWishlistLink = (lid, swat)=>{
    return new Promise((resolve, reject)=>{
        let onSuccess = (link)=>{
            const shareUrl = new URL(link);
            const originUrl = shareUrl.origin;
            const hkey = shareUrl.searchParams.get('hkey');
            const newLid = shareUrl.searchParams.get('lid');
            const customShareUrl = `${originUrl}/pages/shared-wishlist?hkey=${hkey}&lid=${newLid}`;
            resolve(customShareUrl);
        };
        let onError = (error)=>{
            reject(error);
        };
        swat.generateSharedListURL(lid, onSuccess, onError);
    });
};
const emailWishlist = (lid, swat, emailAddress, fromName, note)=>{
    return new Promise((resolve, reject)=>{
        let onSuccess = function(response) {
            resolve(response);
        };
        let onError = function(error) {
            reject(error);
        };
        swat.sendListViaEmail({
            toEmailId: emailAddress,
            fromName: fromName,
            note: note,
            lid: lid
        }, onSuccess, onError);
    });
};
const markListPublic = (lid, swat)=>{
    return new Promise((resolve, reject)=>{
        let onSuccess = function(response) {
            resolve(response);
        };
        let onError = function(error) {
            reject(error);
        };
        swat.markListPublic(lid, onSuccess, onError);
    });
};
/* Check if a product variant is in the wishlist */ export const isInWishlist = (epi, empi)=>{
    if (!window.swymWishLists) return false;
    return window.swymWishLists.some((list)=>list.listcontents.some((item)=>item.empi === empi && item.epi === epi));
};
/* Initializes the wishlist functions by fetching the list and adding event listeners. */ export const init = async (swat)=>{
    try {
        var _window_swymWishLists;
        if ((window === null || window === void 0 ? void 0 : (_window_swymWishLists = window.swymWishLists) === null || _window_swymWishLists === void 0 ? void 0 : _window_swymWishLists.length) === 0) {
            await createList(swat, DEFAULT_WISHLIST_NAME, true);
            window.swymSelectedListName = DEFAULT_WISHLIST_NAME;
        }
        await refreshLists(swat);
        window.dispatchEvent(new CustomEvent('swym:ready'));
    } catch (error) {
        console.error('Error initializing wishlist:', error);
    }
};
/* Push the init functions into SwymCallbacks */ if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(init);
/* Export for use in other modules */ export { addToWishlist, removeFromWishlist, fetchLists, fetchList, deleteList, editList, createList, refreshLists, getShareWishlistLink, emailWishlist, markListPublic };
